import { invokeWithSingleContextHeal } from "@wakeloop/adapter-core";
import { isLikelyOpenCodeContextLostError } from "../context/opencode-context-heal.js";
import { invokeOpenCodeCliTransport } from "../transport/opencode-cli-transport.js";
export class OpenCodeRuntimeError extends Error {
    code;
    errorType;
    constructor(input) {
        super(input.message);
        this.name = "OpenCodeRuntimeError";
        this.code = input.code;
        this.errorType = input.errorType;
    }
}
export async function invokeOpenCodeWithSingleContextHeal(input) {
    const result = await invokeWithSingleContextHeal({
        contextId: input.sessionId,
        createRebuildFailedError: (error) => new OpenCodeRuntimeError({
            code: "context.rebuild_failed",
            errorType: "adapter",
            message: `context.rebuild_failed: ${toErrorMessage(error)}`,
        }),
        invokeOnce: (sessionId) => invokeOpenCodeOnce({
            launchContract: input.launchContract,
            openCodeTimeoutMs: input.openCodeTimeoutMs,
            openCodeWorkdir: input.openCodeWorkdir,
            conversationPolicy: input.conversationPolicy,
            env: input.env,
            executionMode: input.executionMode,
            ...(input.onProcessControlEvent
                ? { onProcessControlEvent: input.onProcessControlEvent }
                : {}),
            ...(input.onRuntimeEvent
                ? { onRuntimeEvent: input.onRuntimeEvent }
                : {}),
            prompt: input.prompt,
            sessionId,
        }).then((value) => ({
            contextId: value.sessionId,
            output: value.output,
            ...(value.telemetry ? { telemetry: value.telemetry } : {}),
        })),
        isContextLostError: (error) => isLikelyOpenCodeContextLostError(error instanceof Error ? error.message : String(error)),
        onContextLost: input.onContextLost,
    });
    return {
        contextHealed: result.contextHealed,
        output: result.output,
        sessionId: result.contextId,
        ...(result.telemetry ? { telemetry: result.telemetry } : {}),
    };
}
async function invokeOpenCodeOnce(input) {
    try {
        return await invokeOpenCodeCliTransport({
            launchContract: input.launchContract,
            openCodeTimeoutMs: input.openCodeTimeoutMs,
            openCodeWorkdir: input.openCodeWorkdir,
            conversationPolicy: input.conversationPolicy,
            env: input.env,
            ...(input.onProcessControlEvent
                ? { onProcessControlEvent: input.onProcessControlEvent }
                : {}),
            ...(input.onRuntimeEvent ? { onRuntimeEvent: input.onRuntimeEvent } : {}),
            prompt: input.prompt,
            sessionId: input.sessionId,
        });
    }
    catch (error) {
        if (error instanceof OpenCodeRuntimeError) {
            throw error;
        }
        if (error &&
            typeof error === "object" &&
            "code" in error &&
            typeof error.code === "string" &&
            "errorType" in error &&
            typeof error.errorType === "string" &&
            error instanceof Error) {
            throw new OpenCodeRuntimeError({
                code: error.code,
                errorType: error.errorType,
                message: error.message,
            });
        }
        throw new OpenCodeRuntimeError({
            code: "upstream_unreachable",
            errorType: "adapter",
            message: `upstream_unreachable: ${toErrorMessage(error)}`,
        });
    }
}
function toErrorMessage(error) {
    if (error instanceof Error) {
        return error.message;
    }
    return String(error);
}
